
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/realms",
      function () {
        return require("private-next-pages/realms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/realms"])
      });
    }
  